import React from 'react';
import LicensingPage from './LicensingPage';
import useLicensingProvider from './useLicensingProvider';
import LicensingContext from './LicensingContext';
import { withTheme } from '@material-ui/core/styles';
import withUserInfo from '../../core/EcrionProvider/boot/withUserInfo';

var Licensing = function Licensing(_ref) {
  var appName = _ref.appName,
      userInfo = _ref.userInfo,
      children = _ref.children,
      checkTrial = _ref.checkTrial,
      history = _ref.history,
      path = _ref.path,
      RedirectComponent = _ref.RedirectComponent;
  var licensing = useLicensingProvider(checkTrial);
  var environment = userInfo.environmentName;
  if (!history) return null;

  var closeLicensingPage = function closeLicensingPage() {
    if (!licensing) return; // no license or no trial, keep this page open
    // defensive check (we cannot close this page if no trial or licensed)

    if (!licensing.hasLicense && !licensing.hasTrial) return; // replace

    if (history.replace) history.replace('/');
  };

  var onStartTrial = function onStartTrial() {
    licensing.actions.startTrial(function () {
      if (history.replace) history.replace('/');
    });
  }; // we show licensing page only at a specified location


  if (history.location.pathname.startsWith(path)) {
    return React.createElement(LicensingPage, {
      appName: appName,
      environment: environment,
      licensing: licensing,
      onStartTrial: onStartTrial,
      onContinueTrial: closeLicensingPage
    });
  }

  if (licensing.initializing) {
    return React.createElement(LicensingPage, {
      appName: appName,
      environment: environment,
      licensing: licensing
    });
  }

  if (!licensing.hasLicense && !licensing.hasTrial) return React.createElement(RedirectComponent, {
    to: path
  });
  return React.createElement(LicensingContext.Provider, {
    value: {
      IsTrial: licensing.hasTrial,
      RemainingDays: licensing.remainingDays
    }
  }, children);
};

Licensing.defaultProps = {
  path: '/licensing'
};
export default withTheme(withUserInfo(Licensing));